import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { AuthenticationService } from 'src/app/core/services/Authentication/authentication.service';
import { AdminService } from 'src/app/core/services/admin-apis/admin.service';
import { HitmakerService } from 'src/app/core/services/hitmaker/hitmaker.service';

@Component({
  selector: 'app-release',
  templateUrl: './release.component.html',
  styleUrls: ['./release.component.css']
})
export class ReleaseComponent implements OnInit {

  movieId: any;
  stageName: any;
  castingDetails: any;
  data: any;
  stageContentDTOs: any[] = [];
  playVideo = false;
  admin = false;
  public video: any;
  userId: any;
  movieName: any;

  constructor(private router: Router, private activatedRoute: ActivatedRoute,
    private hitmakerService: HitmakerService,
    public auth: AuthenticationService,
    public sanitizer: DomSanitizer, private adminApi: AdminService) { }
  

     
    ngOnInit(): void {
      this.adminApi.getCreaticsHomepage().subscribe(data => {
    
        this.userId = data.userId;
        })
    this.auth.checkUserAuthenticated().subscribe((data: any) => {
      var role = data.adminRole
      if (!role) {
        this.admin = false
      }
      else {
        this.admin = true
      }
    })
    this.movieId = this.activatedRoute.snapshot.params['id'];

    this.getMovieDetails();
    this.stageName = 'release';
    this.hitmakerStageDetails();

  }

  hitmakerStageDetails() {
    this.hitmakerService.getHitmakerStageDetails(this.movieId, 'RELEASE').subscribe((response) => {
      this.castingDetails = response;
      if(!this.castingDetails.showThumbnail && !this.admin){
        alert("Stay tuned for more updates!");
        this.router.navigate(['/hitmaker/' + this.movieId]);
      }
      this.data = JSON.stringify(this.castingDetails);
      this.stageContentDTOs = this.castingDetails?.stageContent[0]?.stageContentDTOs;
    })
  }

  uploadDetails() {
    this.router.navigate(['/hitmaker/' + this.movieId + '/stage/' + this.stageName + '/upload']);
  }

  playVideo1(details: any) {
    this.playVideo = true;
    this.video = this.sanitizer.bypassSecurityTrustResourceUrl(details);
  }

  closeVideo() {
    this.video = '';
    this.playVideo = false;
  }

  deleteStageMovie(stageId: any) {
    if (confirm('Permanently delete the content?')) {
      this.hitmakerService.deleteStageContent(stageId).
        subscribe(() => {
          this.hitmakerStageDetails();
        })
    } else {
    }
  }

  hideStageContent(details: any) {
    if (confirm('Toggle the public visibility of the content? (Note - Hidden content will only be visible to the producers of this movie or Creatics admins)')) {
      this.hitmakerService.hideStageContent(details.id, true).
        subscribe(() => {
          details.hidden = true;
        })
    } else {
    }
  }

  showStageContent(stageId: any) {
    if (confirm('Toggle the public visibility of the content? (Note - Hidden content will only be visible to the producers of this movie or Creatics admins)')) {
      this.hitmakerService.hideStageContent(stageId, false).
        subscribe((response) => {
          if (response) {
            window.location.reload();
          }
        })
    } else {
    }
  }

  updateShowContent(details: any) {

    this.router.navigate(
      ['/hitmaker/'+ this.movieId + '/stage/'+ this.stageName + '/update/' + details.id]
      
    );
  }

  upvoteContent(details: any) {
    this.hitmakerService.getUserUpvoteBalnce().subscribe((balanceResponse: any) => {
      const userBalance = balanceResponse - 1;

      if (userBalance >= 0) {
        this.hitmakerService.upvoteStageContent(details.id).subscribe((response) => {
          if (response) {
            alert(`Congratulations, you got 5 currency points! Your free Jewel balance for today is ${userBalance}`);
            this.hitmakerStageDetails();
          }
        }, (error) => {
          alert('Episode already jeweled!');
        });
      } else {
        alert('You have already used up your 10 free jewels for today.');
      }
    });
  }
  getMovieDetails() {
    this.adminApi.getHitmakerMoviePage(this.movieId).subscribe((data) => {
      this.movieName = data.movieName;

      console.log(this.movieName);
    });
  }
  screening(){
      alert("'FANS SCREENING AND VOTE' contest for this movie is coming soon. Stay tuned!");
  }
}
